import React, { useEffect, useState } from 'react'
import Dialog from '@mui/material/Dialog'
import './ExtendLeaseModal.scss'

// Push a lease out to a new end date. One field, because that is the whole
// action — the caller has already decided which lease is being extended and
// supplies the store call that saves it, so this modal never learns whether it
// is editing a hand-recorded car or a sold one.
//
// `currentDate` and the value handed to `onSave` are both ISO 'YYYY-MM-DD',
// which is what <input type="date"> speaks. Converting for the opportunity
// endpoint is the caller's job, at the wire boundary.
export const ExtendLeaseModal = ({ open, currentDate = '', onClose, onSave }) => {
    const [date, setDate] = useState('')
    const [saving, setSaving] = useState(false)

    useEffect(() => {
        if (!open) return
        setDate(currentDate || '')
        setSaving(false)
    }, [open, currentDate])

    const submit = async () => {
        if (!date || saving) return
        setSaving(true)
        try {
            await onSave(date)
            onClose()
        } catch (e) {
            /* toast handled in the store; the modal stays open with its value */
        } finally {
            setSaving(false)
        }
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth={false} PaperProps={{ className: 'extend-lease-modal' }}>
            <div className="modal-head">
                <div>
                    <div className="modal-title">Extend Lease</div>
                    <div className="modal-sub">Set a new expiration date for this lease.</div>
                </div>
                <button className="modal-x" onClick={onClose} aria-label="Close">✕</button>
            </div>

            <div className="modal-body">
                <div className="mfield">
                    <div className="mfield-label">Expiration Date</div>
                    {/* Deliberately no `max`: an extension has no ceiling. */}
                    <input
                        type="date"
                        aria-label="Expiration Date"
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                    />
                </div>
            </div>

            <div className="modal-foot">
                <button className="btn-ghost" onClick={onClose}>Cancel</button>
                <button className="btn-add" onClick={submit} disabled={saving || !date}>
                    {saving ? 'Saving…' : 'Save'}
                </button>
            </div>
        </Dialog>
    )
}
